import { createAction } from '@reduxjs/toolkit';
import { LoginRequest } from './Types';

export const login = createAction<LoginRequest>('auth/login');
export const logout = createAction('auth/logout');